import { Typography, Tooltip, Icon } from '@scale/scaleui';
import OpenRubricButton from 'react-scale/components/scalers/tasks/textcollection/OpenRubricButton';
import Markdown from '@scale/frontend-lib/markdown';

interface FieldHeaderProps {
  title: string;
  description?: string;
  hint?: string;
  rubric?: string;
}

export default function FieldHeader({ title, description, hint, rubric }: FieldHeaderProps) {
  return (
    <div className="flex flex-col gap-2 mb-2">
      <div className="flex justify-between">
        <div className="flex flex-row">
          <Typography.Paragraph1>{title}</Typography.Paragraph1>
          {hint && (
            <Tooltip
              asChild
              side="top"
              text={hint}
              target={
                <div>
                  <Icon icon={['far', 'info-circle']} size="sm" />
                </div>
              }
            />
          )}
        </div>
        {rubric && <OpenRubricButton rubric={rubric} />}
      </div>
      <Typography.Paragraph3>
        <div
          dangerouslySetInnerHTML={{
            __html: description ? Markdown.renderInline(description) : '',
          }}
        />
      </Typography.Paragraph3>
    </div>
  );
}
